import { render, staticRenderFns } from "./ActivitySegment.vue?vue&type=template&id=7584e3c7&scoped=true"
import script from "./ActivitySegment.vue?vue&type=script&lang=ts"
export * from "./ActivitySegment.vue?vue&type=script&lang=ts"
import style0 from "./ActivitySegment.vue?vue&type=style&index=0&id=7584e3c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7584e3c7",
  null
  
)

export default component.exports